import React from 'react'
import * as Displays from 'support/displays'
import { ForEachModel, ModelProxy, SortBy, ValueToCollection, WhenModel } from '@morningtrain/react-resources'
import Slot from 'widgets/shifts/themes/list/Slot'

export default function ListDay ({ mode = 'view' }) {
  return (
    <div className='group space-y-4'>
      <div className='text-xl font-medium mb-6 capitalize'>
        <Displays.Date name='key' dateFormat='dddd - DD.MM.YYYY' />
      </div>

      <ValueToCollection name='collection'>
        <ForEachModel>
          <ModelProxy>
            <WhenModel>
              <Slot mode={mode} />
            </WhenModel>
          </ModelProxy>
        </ForEachModel>
      </ValueToCollection>
    </div>
  )
}
